import { FormDefinition } from '@/types';

export default function useStringFormatter() {
    function camelCaseToLabel(label: string): string {
        const result = label.replace(/([A-Z])/g, ' $1');
        return result.charAt(0)
            .toUpperCase() + result.slice(1);
    }

    function getLabelFromFormDefinition(def: FormDefinition<any>): string {
        let label = '';
        if (def.label) label = def.label;
        else label = camelCaseToLabel(def.key as string);
        if (def.required) label += '*';
        return label;
    }

    function capitalizeFirstLetter(word: string): string {
        if (!word) return word;
        return word[0].toUpperCase() + word.substr(1).toLowerCase();
    }

    function convertAsmTimeToString(value: number, toggleHours: boolean): string {
        if (!value) {
            return '';
        }
        let totalEstAsmTime = (value * 60);
        let fractionalAsmTime = totalEstAsmTime - Math.floor(totalEstAsmTime);
        fractionalAsmTime = fractionalAsmTime * 60;
        let fractionalAsmTimeString;
        fractionalAsmTime.toString().length > 3 ?
            fractionalAsmTimeString = fractionalAsmTime.toString().substring(0,4) :
            fractionalAsmTimeString = fractionalAsmTime.toString();

        if (Math.floor(totalEstAsmTime) > 0) {
            if (toggleHours && totalEstAsmTime > 60) {
                let hours = Math.floor(totalEstAsmTime / 60);
                return hours + ' hr ' + Math.floor(totalEstAsmTime - (hours * 60)) + ' Min ' + fractionalAsmTimeString + ' Sec';
            } else {
                return Math.floor(totalEstAsmTime) + ' Min ' + fractionalAsmTimeString + ' Sec';
            }
        }
        return fractionalAsmTimeString + ' Sec';
    }

    return {
        getLabelFromFormDefinition,
        camelCaseToLabel,
        capitalizeFirstLetter,
        convertAsmTimeToString
    };
}
